import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../services/commons-service.service";
import {SplitService} from "../../services/split-service.service";

export class ProgramTypesMultiSelectListCtrl implements IController {
  programIds: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public isSelectAll: boolean;

  constructor(private splitService: SplitService, private commonsService: CommonsService) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.splitService.getSiteProgramTypes();
    }
  }

  $onChanges(changes) {
    if (changes.programIds) {
      this.selectedKeys = {};
      _.forEach(this.programIds, id => {
        this.selectedKeys[id] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      programIds: isSelected ? _.concat(this.programIds || [], [option.id]) :
        _.filter(this.programIds, (id) => {
          return id !== option.id;
        })
    });
  }

  onReset() {
    this.onChange({programIds: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      // this.onChange({programIds: this.options?.map(p => p.id) || []});
      const options = this._getFilteredOptions();
      this.onChange({programIds: options?.map(p => p.id) || []});
    }
  }


  isAllSelected() {
    const options = this._getFilteredOptions();
    this.isSelectAll = this.commonsService.checkIfArraysMatch(options?.map(p => p.id), this.programIds);
    return this.isSelectAll;
  }

  private _getFilteredOptions() {
    return !!this.queryString ? this.options?.filter(o => {
      return _.includes(JSON.stringify(o).toLowerCase(), this.queryString.toLowerCase())
    }) : this.options;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('programTypesMultiSelectList', {
    bindings: {
      programIds: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./program-types-multi-select-list.html').default,
    controller: ProgramTypesMultiSelectListCtrl
  });
